import scriptLoader from './scriptLoader'
import { getSystem } from './index';
//重试次数
const REPEAT_COUNT = 2

export async function JRSDK(cb) {
  if(window.JrBridge) {
    cb();
    return ;
  }
  try {
    if(!window.JrBridge) {
      await scriptLoader('https://m.jr.jd.com/common/jssdk/jrbridge/2.0.7/jrbridge.js')(REPEAT_COUNT)
    }
    cb()
  } catch (e) {
    console.error('金融sdk加载失败');
  } finally {
  }
}


export async function JDSDK(cb) {
  if(window.JSSDK) {
    cb();
    return ;
  }
  try {
    await scriptLoader('https://storage.360buyimg.com/bbf/jssdk.min.js')(REPEAT_COUNT)
    cb()
  } catch (e) {
    console.error('京东sdk加载失败');
  } finally {
  }
}

export function setMenu(info = {}) {
  window.JrBridge.setMenuPanel({
    isShow: info.isShow,
   })
}

export function setShare(info = {}) {
  if(getSystem().isJr) {
  JRSDK(() => {
      const config = {
        isShow: true,
        shareDataNew: {
          link: [
            info.link || window.location.href,
            ],
          linkSubtitle: info.subTitle,
          imageUrl: info.img,
          linkTitle:  info.mainTitle,
         
        
        }
      };
      window.JrBridge.setShareConfig(config)
  })
}
  else if(getSystem().isJd) {
    JDSDK(() => {
      
      window.JSSDK &&
      window.JSSDK.WebView && 
      window.JSSDK.WebView.callHeaderSharePanel({
        title: info.mainTitle,
        content: info.subTitle,
        shareUrl: info.link || window.location.href,
        iconUrl: info.img,
        //callfunc: cb
    });
    })  
      
  
  }
}

export function setTopBar({ title, bg = '#ffffff' }) {
  document.title = title;
  if(getSystem().isJr) {
    JRSDK(() => {
      var confs = {
        "title": title,
        "moreItem": true,
        "backColor": [bg],
        "textColor": 1,
      }
      if(bg === '#ffffff') {
        confs.textColor = 2;
      }
      window.JrBridge.setTopBar(confs);
    })  
  }else if(getSystem().isJd) {
    JDSDK(() => {
      let confs = {
        naviIcon: '2',
        backgroundColor: bg
      }
      if(bg === '#ffffff') {
        confs.naviIcon = '1';
      }
      window.JSSDK &&
      window.JSSDK.WebView && 
      window.JSSDK.WebView.setNaviBackground &&
      window.JSSDK.WebView.setNaviBackground({
          naviIcon: confs.naviIcon,
          backgroundColor: confs.backgroundColor,
          //pic: "https://m.360buyimg.com/babel/jfs/t2593/359/904272974/12646/793b4297/572abb20N41e8bd85.png"
      });
      
    })  
  
  }
    
}
